// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Implantacao_ArquivoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** GET /implantacao/arquivo — link temporário (1 h) para o arquivo de um item. */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Implantacao_ArquivoResponseDados {
url: string
nome: string
}

export type Implantacao_ArquivoResponse = ApiResponse<Implantacao_ArquivoResponseDados>;

registerResponseContract('Implantacao_ArquivoResponse', {
  url:  { type: 'string',  required: true },
  nome: { type: 'string',  required: true },
})
